<script setup lang="ts">
import {NotificationTemplate as INotificationTemplate} from "@/notification-template/interfaces";
import BaseFlexSpinner from "@/core/components/base/spinner/BaseFlexSpinner.vue";
import NotificationTemplate from "@/notification-template/components/NotificationTemplate.vue";

defineProps<{
    templates: INotificationTemplate[];
    loading: boolean;
}>();

defineEmits<{
    (e: 'selected', template: INotificationTemplate);
}>();
</script>

<template>
  <div>
    <BaseFlexSpinner v-if="loading" />
    <div v-else-if="templates?.length" class="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      <NotificationTemplate
        v-for="template in templates"
        :key="template.id"
        :template="template"
        selectable
        @selected="$emit('selected', template)"
      />
    </div>
    <div v-else class="text-center">
      Aucun modèle de notification trouvé.
    </div>
  </div>
</template>

<style scoped>

</style>
